var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Acceso Denegado")]),_c('p',[_vm._v("No tiene permiso para acceder a esta vista.")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Volver al Inicio")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }